import { useNavigate } from 'react-router-dom';
import usePiecework from '../../features/piecework/usePiecework';
import Badge from '../badge';
import { BadgeBackgroundColorEnum, BadgeTextColorEnum } from '../badge/enums';
import IndividualCircularLoader from '../Loader/IndividualCircularLoader';

const AdsInfos = () => {
  const { totalAds, totalNewAds, marketResearchStatusPending } = usePiecework({});
  const navigate = useNavigate();

  if (marketResearchStatusPending) {
    return (
      <div className="dashboard-section-content">
        <IndividualCircularLoader size={100} />
      </div>
    );
  }

  return (
    <div className="dashboard-section-content">
      <div
        className="dashboard-info-card"
        style={{ backgroundImage: 'url(./images/frame-building.png)' }}
        onClick={() => navigate('/pige-classique')}
      >
        <div className="dashboard-info-card-data">
          <span className="dashboard-info-card-nb">{totalAds}</span>
          <span className="dashboard-info-card-type">Annonces publiées</span>
        </div>
        <Badge
          badgeDynamicContent={`${
            totalNewAds === 200 ? '+ de ' : ''
          } ${totalNewAds} nouvelles annonces`}
          bgColor={BadgeBackgroundColorEnum.RED}
          textColor={BadgeTextColorEnum.WHITE}
          isMini
        />
      </div>
    </div>
  );
};

export default AdsInfos;
